module.exports = __webpack_public_path__ + "static/media/cafe.1dc678bf.webp";